import gearIndex from './gearIndex.md';
import getGear from './gear.md';

const gear = [
    gearIndex,
    getGear
];

export default gear;